import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DebounceInput } from 'react-debounce-input';

import Utils from '../../../Services/Utils';

import withShallowComparison from '../../Common/withShallowComparisonUpdate';
import InputWrapper from '../WrapperInput';

import './style.scss';
import $ from "../../../../offline/jquery.min";

const namePattern = {
  pattern: new RegExp('(?:^[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])'),
  error: 'Invalid email.'
};

class InputEmail extends React.PureComponent {

  constructor(props) {
    super(props);
    this.emailInput = React.createRef();
  }

  componentDidMount() {
    this.initValidate();
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  }

  validate = (value) => {
    const { required, validators, maxlength, minlength } = this.props;
    if (required && Utils.isNull(value)) return 'This field is required.';
    if (maxlength && (!Utils.isNull(value) && (value.length > parseInt(maxlength)))) {
      return 'This field must have a maximum of ' + maxlength + ' characters';
    }
    if (minlength && (Utils.isNull(value)|| (value.length < parseInt(minlength)))) {
      return 'This field must have a minimum of ' + minlength + ' characters';
    }
    if (!Utils.isNull(value) && !namePattern.pattern.test(value)) return namePattern.error;
    for (const validator of validators || []) {
      if (validator(value)) return validator(value);
    }
    return '';
  };

  handleChange = (e) => {
    const { onChange, onError, error } = this.props;
    const value = e && e.target ? e.target.value : e;
    if (onChange) onChange(value);
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  handleKeyDown = (e) => {
    const { onSubmit, maxlength } = this.props;
    if (e.keyCode !== 8) {
      if (e.keyCode === 13) {
        if (onSubmit) onSubmit();
        e.preventDefault();
      }
      else {
        if ($(this.emailInput.current).val().toString().length === parseInt(maxlength)) {
          e.preventDefault();
        }
      }
    }
  };

  render() {
    const {
      className,
      label,
      labelhtml,
      error,
      placeholder,
      disabled,
      required,
      value,
      disablechange,
      debounce,
      onChange,
      onBlur,
      onClick,
      onFocus,
      onKeyDown,
      readOnly
    } = this.props;

    const WrapperProps = {
      className,
      label,
      labelhtml,
      error,
      required,
    };

    const debounceTimeout = !Utils.isNull(debounce) ? debounce : 500;

    const changeProps = {
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      onClick: onClick,
      onKeyDown: onKeyDown,
    };
    if (!disablechange) {
      changeProps['onChange'] = this.handleChange;
    }
    
    return (
      <InputWrapper { ...WrapperProps }>
        <DebounceInput
          inputRef={ this.emailInput }
          type="email"
          debounceTimeout={ debounceTimeout }
          value={ !Utils.isNull(value) ? value : '' }
          disabled={ disabled }
          required={ required }
          readOnly={ readOnly }
          onKeyDown={ this.handleKeyDown }
          {...changeProps}
          className={ classNames('InputText', {
            InputText_Disabled: Boolean(disabled),
          }) }
          placeholder={ placeholder }
        />
      </InputWrapper>
    );
  }
}

InputEmail.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  validators: PropTypes.array,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  debounce: PropTypes.number,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onError: PropTypes.func,
  disablechange: PropTypes.string
};

export default withShallowComparison(InputEmail, ['onChange', 'onError']);